import React, { Component } from 'react';
import { Collapse, FormGroup } from 'reactstrap';
import Select from 'react-select';
import moment from 'moment';
import { connect } from 'react-redux';
import QuarterHourTimeSelect from '../../../common/QuarterHourTimeSelect';
import { getDoctorsByFacility } from '../../../../redux/actions/referralDoctorAction';
import { getStaffDoctorsByFacility } from '../../../../redux/actions/staffActions';
import DatePickerComponent from '../../Common/DatePickerComponent';
import Error from '../../../../shared/components/form/Error';
import config from '../../../../config/app.config';
import MessageModal from '../../../../shared/components/Modals/MessageModal';
import AppointmentTypesSelect from '../../../common/AppointmentTypesSelect';
import { DEFAULT_TIMESTAMP_FORMAT } from '../../../../constants/constants';
import {
  formatStaffDoctorOptionLabel,
  mapStaffDoctorsFromApi,
  mergeStaffDoctorSelectStyles,
} from '../../../../utils/staffDoctorSelect';

const CREATE_APPT_DOCTOR_SELECT_STYLES = {
  control: (base, state) => ({
    ...base,
    minHeight: 32,
    height: 32,
    fontSize: 12,
    fontWeight: 400,
    borderColor: state.isFocused ? '#00b0ec' : '#ced4da',
    boxShadow: 'none',
    borderRadius: 0,
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0 8px',
    height: 30,
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: 30,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: '0 6px',
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: '0 4px',
  }),
  placeholder: (base) => ({
    ...base,
    color: '#818383',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 'normal',
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 'normal',
    color: '#15153e',
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: '#f5f7f6',
  }),
  menuList: (base) => ({
    ...base,
    backgroundColor: '#f5f7f6',
  }),
};

class CreateAppointmentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      referringDoctorList: [],
      staffDoctorList: [],
      loadingRefDoctors: true,
      loadingDoctors: true,
      responseBox: {
        showResponse: false,
        responseType: '',
        responseAlertType: '',
        responseFooter: '',
        message: '',
        onSuccess: null,
        notified: false,
      },
  appointmentTime: props.createData?.appointmentTime
    ? moment(props.createData.appointmentTime)
    : !props.reschedule
      ? this.getDefaultAppointmentTime()
      : null,
};
this.handlePopup = this.handlePopup.bind(this);
this.onClose = this.onClose.bind(this);
this.isNotSubscribed = this.isNotSubscribed.bind(this);
this.handleReferringDocChange = this.handleReferringDocChange.bind(this);

if (!props.reschedule && !props.createData?.appointmentTime) {
  this.props.handleTimeChange(this.state.appointmentTime);
}
  }

  handleReferringDocChange(e) {
    if (e && this.isNotSubscribed(e.value)) {
      this.props.onChangeSelect(e, 'referringDoctor', true);
    } else {
      this.props.onChangeSelect(e, 'referringDoctor');
    }
  }

componentDidMount() {
  this.setState({
    loadingRefDoctors: true,
    loadingDoctors: true,
  });
  this.props.getDoctorsByFacility();
  this.props.getStaffDoctorsByFacility();

  const { reschedule, createData, handledateChange } = this.props;
  if (!reschedule && !createData?.appointmentDate && handledateChange) {
    const utcOffset =
      this.props.user?.profile?.facility?.utcOffset || 0;
    handledateChange(this.getDefaultAppointmentDate(utcOffset));
  }
}

  getRoundedMomentTime() {
    const date = moment();

    if (date.minute() <= 10 && date.minute() > 0) {
      date.minute(0);
    } else {
      const roundedUp = Math.ceil(date.minute() / 15) * 15;
      date.minute(roundedUp);
    }
    date.second(0);
    return date;
  }

  getDefaultAppointmentTime() {
  return moment().hours(13).minutes(0).seconds(0).milliseconds(0);
}

getDefaultAppointmentDate(utcOffset = 0) {
  return moment()
    .utc()
    .add(utcOffset || 0, 'minutes')
    .startOf('date')
    .add(1, 'day')
    .format(DEFAULT_TIMESTAMP_FORMAT);
}

  getDoctorList(list, type) {
    switch (type) {
      case 'staffDoctor':
        return mapStaffDoctorsFromApi(list);
      case 'referringDoctor':
        return list.map((value) => ({
          value: value.doctorId,
          label: value.name,
          subscriptionStatus: value.subscriptionStatus,
        }));

      default:
        return [];
    }
  }

  UNSAFE_componentWillReceiveProps(np) {
    if (np.refDoctor && np.refDoctor.referringDoctorList) {
      const referringDoctorList = this.getDoctorList(
        np.refDoctor.referringDoctorList,
        'referringDoctor',
      );
      this.setState({
        referringDoctorList,
        loadingRefDoctors: false,
      });
    }

    if (np.staff && np.staff.staffDoctorsByFacility) {
      const staffDoctorList = this.getDoctorList(
        np.staff.staffDoctorsByFacility,
        'staffDoctor',
      );
      this.setState({
        staffDoctorList,
        loadingDoctors: false,
      });
    }

    if (np.createData && np.createData.appointmentTime) {
      const appointmentTime = np.createData.appointmentTime;
      this.setState({ appointmentTime });
    }
  }

  handlePopup(type) {
    const { responseBox } = this.state;
    responseBox.showResponse = true;
    responseBox.responseFooter = true;
    responseBox.responseType = 'alert';
    responseBox.responseAlertType = 'info';
    switch (type) {
      case 'referringDoctor':
        responseBox.message =
          'Referring doctor you selected is now inactive. Please activate or select a new referring doctor to proceed.';
        break;
      case 'doctor':
        responseBox.message =
          'Doctor you selected is now inactive. Please activate or select a new doctor to proceed.';
        break;
      case 'referringDoctorAndDoctor':
        responseBox.message =
          'Both doctor and referring doctor you selected are now inactive. Please activate or select a new doctor and a referring doctor to proceed.';
        break;
      default:
        break;
    }
    responseBox.onSuccess = this.onClose;
    this.setState({
      responseBox,
      notified: true,
      resetType: type,
    });
  }

  onClose() {
    const { responseBox, resetType } = this.state;

    responseBox.showResponse = false;
    responseBox.responseType = '';
    responseBox.responseAlertType = '';
    responseBox.responseFooter = '';
    responseBox.message = '';

    this.setState({ responseBox }, () => {
      this.props.resetData(resetType);
    });
  }

  isNotSubscribed(referringDoctor) {
    const { referringDoctorList } = this.state;
    const currentItem = referringDoctorList.filter(
      (item) => item.value === referringDoctor,
    );
    if (currentItem[0]) {
      return (
        currentItem[0].subscriptionStatus !==
        config.SUBSCRIPTION_STATUS.SUBSCRIBED
      );
    }
    return false;
  }

  timePickerOnChange(e) {
    if (e) {
      this.setState({ appointmentTime: e });
      this.props.handleTimeChange(e.toDate());
    }
  }

  render() {
    const {
      referringDoctorList,
      staffDoctorList,
      loadingRefDoctors,
      loadingDoctors,
      responseBox,
      notified,
    } = this.state;
    const { viewMode, reschedule, portalMenus } = this.props;
    const {
      appointmentDate,
      appointmentType,
      doctor,
      referringDoctor,
      // shareUpdates,
      errors,
      collapse,
      endDate,
      isDaycare,
    } = this.props.createData;

    if (reschedule && !loadingRefDoctors && !notified && !loadingDoctors) {
      const refDocIds = referringDoctorList.map(
        (currentValue) => currentValue.value,
      );
      const docIds = staffDoctorList.map((currentValue) => currentValue.value);

      if (
        referringDoctor &&
        refDocIds.indexOf(referringDoctor) === -1 &&
        doctor &&
        docIds.indexOf(doctor) === -1
      ) {
        this.handlePopup('referringDoctorAndDoctor');
      } else {
        if (referringDoctor && refDocIds.indexOf(referringDoctor) === -1) {
          this.handlePopup('referringDoctor');
        }

        if (doctor && docIds.indexOf(doctor) === -1) {
          this.handlePopup('doctor');
        }
      }
    }

    return (
      <>
        {responseBox.showResponse && (
          <MessageModal
            show={responseBox.showResponse}
            type={responseBox.responseType}
            alertType={responseBox.responseAlertType}
            footer={responseBox.responseFooter}
            onSuccess={responseBox.onSuccess}
            onClose={this.onClose}
            message={responseBox.message}
          />
        )}
        <div className="content-holder create">
          <div className="row">
            <div className="col-md-12">
              <Collapse isOpen={collapse}>
                <div className="row">
{isDaycare && (
  <div className="col-md-12" style={{ marginBottom: '24px' }}>
    <div
      style={{
        fontSize: '13px',
        color: '#50514f',
        fontWeight: 400,
        lineHeight: 1.35,
      }}
    >
      <div>Select a Stay Date first.</div>
      <div style={{ marginTop: '5px' }}>
        Same Start Date and End Date creates one visit.
      </div>
      <div style={{ marginTop: '3px' }}>
        A later End Date creates one visit per day in the range.
      </div>
    </div>
  </div>
)}
                  <div className="col-md-3">
                    <div className="form__form-group loyal-custom-form-group">
                      <span className="form__form-group-label">
                        {this.props.labels?.appointmentDate ?? 'Appointment Date'} <span className="required">*</span>
                      </span>
                      <div className="form__form-group-field">
                        <FormGroup>
                          <DatePickerComponent
                            minDate
                            maxDate={false}
                            viewMode={viewMode}
                            date={appointmentDate}
                            handleChange={this.props.handledateChange}
                            portalMenu={!!portalMenus}
                            compact
                          />
                          {errors.appointmentDate && (
                            <Error text={errors.appointmentDate} />
                          )}
                        </FormGroup>
                      </div>
                    </div>
                  </div>

{isDaycare && (
  <div className="col-md-3">
    <div className="form__form-group loyal-custom-form-group">
      <span className="form__form-group-label">
        End Date <span className="required">*</span>
      </span>
      <div className="form__form-group-field">
        <FormGroup>
          <DatePickerComponent
            minDate={appointmentDate || true}
            maxDate={false}
            viewMode={viewMode}
            disabled={!appointmentDate}
            date={endDate}
            handleChange={this.props.handleEndDateChange}
            portalMenu={!!portalMenus}
            compact
          />
          {errors.endDate && (
            <Error text={errors.endDate} />
          )}
        </FormGroup>
      </div>
    </div>
  </div>
)}

  {!this.props.isBoardingOnly && (
    <div className="col-md-3">
      <div className="form__form-group loyal-custom-form-group">
        <span className="form__form-group-label">
          Time <span className="required">*</span>
        </span>
        <FormGroup>
<QuarterHourTimeSelect
  value={this.state.appointmentTime}
  onChange={(e) => this.timePickerOnChange(e)}
  placeholder="HH:MM AM"
  name="time"
/>

                  {errors.time && <Error text={errors.time} />}
      </FormGroup>
    </div>
  </div>
  )}

  {this.props.isBoardingOnly && (
  <div className="col-md-3">
    <div className="form__form-group loyal-custom-form-group">
      <span className="form__form-group-label">
        {this.props.labels?.appointmentType ?? 'Appointment Type'} <span className="required">*</span>
      </span>
      <div className="form__form-group-field capitalize-option">
        <FormGroup>
          <AppointmentTypesSelect
            handleChange={this.props.handleChange}
            disabled={viewMode}
            value={appointmentType}
          />
          {errors.appointmentType && (
            <Error text={errors.appointmentType} />
          )}
        </FormGroup>
      </div>
    </div>
  </div>
  )}
</div>
<div className="row">
  {!this.props.isBoardingOnly && (
    <div className="col-md-3">
      <div className="form__form-group loyal-custom-form-group">
        <span className="form__form-group-label">Doctor</span>
        <div className="form__form-group-field">
          <FormGroup>
<Select
  value={staffDoctorList.filter(
    (option) => option.value === doctor,
  )}
  onChange={(e) =>
    this.props.onChangeSelect(e, 'doctor')
  }
  matchProp="_id"
  disabled={viewMode}
  classNamePrefix="create-appt-doctor-select"
  className="custom-select-control"
  options={staffDoctorList}
  formatOptionLabel={formatStaffDoctorOptionLabel}
  placeholder="Select Doctor"
  clearable
  name="doctor"
  styles={mergeStaffDoctorSelectStyles({
    ...CREATE_APPT_DOCTOR_SELECT_STYLES,
    ...(portalMenus
      ? {
          menuPortal: (base) => ({
            ...base,
            zIndex: 2000,
          }),
        }
      : {}),
  })}
  {...(portalMenus
    ? {
        menuPortalTarget: document.body,
        menuPosition: 'fixed',
        menuShouldScrollIntoView: false,
      }
    : {})}
/>
            {errors.doctor && <Error text={errors.doctor} />}
          </FormGroup>
        </div>
      </div>
    </div>
    )}

{!this.props.isBoardingOnly && (
<div className="col-md-3">
  <div className="form__form-group loyal-custom-form-group">
    <span className="form__form-group-label">
      {this.props.labels?.appointmentType ?? 'Appointment Type'} <span className="required">*</span>
    </span>
    <div className="form__form-group-field capitalize-option">
      <FormGroup>
        <AppointmentTypesSelect
          handleChange={this.props.handleChange}
          disabled={viewMode}
          value={appointmentType}
        />
        {errors.appointmentType && (
          <Error text={errors.appointmentType} />
        )}
      </FormGroup>
    </div>
  </div>
</div>
)}

<div className="col-md-3">
  {/* <div className="form__form-group loyal-custom-form-group">
                      <span className="form__form-group-label">
                        Referring Doctors
                      </span>
                      <div className="form__form-group-field">
                        <FormGroup>
                          <Select
                            value={referringDoctorList.filter(
                              (option) => option.value === referringDoctor,
                            )}
                            onChange={this.handleReferringDocChange}
                            disabled={viewMode}
                            className="custom-select-control"
                            options={referringDoctorList}
                            placeholder="Select Referring Doctor"
                            name="referringDoctor"
                          />
                          {errors.referringDoctor && (
                            <Error text={errors.referringDoctor} />
                          )}
                          <div className="form__form-group loyal-custom-form-group clearfix">
                            <div>
                              <label className="custom-toggle-switch pull-right">
                                <input
                                  type="checkbox"
                                  disabled={
                                    viewMode ||
                                    referringDoctor === '' ||
                                    !referringDoctor ||
                                    this.isNotSubscribed(referringDoctor)
                                  }
                                  name="shareUpdates"
                                  checked={shareUpdates}
                                  onChange={this.props.handleShareUpdates}
                                />
                                <span className="custom-toggle-slider round" />
                              </label>
                            </div>
                            <div>
                              <p className="form__form-group-label share-updates">
                                Share Updates
                              </p>
                            </div>
                          </div>
                        </FormGroup>
                      </div>
                    </div> */}
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = {
  getDoctorsByFacility,
  getStaffDoctorsByFacility,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateAppointmentForm);
